import * as React from 'react';
import { runtimeEvents } from '@shared/runtime-events';
import { useRuntimeStore } from './useRuntimeStore';

export default function RuntimeEventsBridge() {
  const reset = useRuntimeStore((s) => s.resetRun);
  const apply = useRuntimeStore((s) => s.applyTelemetry);
  const setStatus = useRuntimeStore((s) => s.setRunStatus);

  React.useEffect(() => {
    const offReset = runtimeEvents.on('run:reset', ({ runId, flowId }) => {
      reset(runId, flowId);
    });
    const offTel = runtimeEvents.on('telemetry', (d) => {
      apply(d as any);
    });
    const offEnd = runtimeEvents.on('end', (e) => {
      const mapped = e.status === 'completed' ? 'succeeded' : e.status;
      setStatus(mapped as any);
    });
    return () => {
      try { offReset(); offTel(); offEnd(); } catch {}
    };
  }, [reset, apply, setStatus]);

  return null;
}
